/* Manu AI v19 (22/10/2026) — choix du style : 6 vignettes (1re = « Choisis pour moi », puis 5 styles au hasard)
 * + une ligne « Autres styles » qui tire 5 autres styles sans nouveau message. Remplace les 3 vignettes + les pastilles
 * « Choisis pour moi » / « Voir tous les styles ». Garde data-act="pick-style" (ai-studio.js) pour un style, et la commande style-any
 * pour « Choisis pour moi ». S'appuie sur l'instance section._ais (v9 → v18 chargés avant). */
(function () {
  'use strict';
  var TXT = {
    fr: { any: 'Choisis pour moi', more: 'Autres styles' },
    en: { any: 'Pick for me', more: 'More styles' },
    es: { any: 'Elige por mí', more: 'Más estilos' },
    de: { any: 'Wähl für mich', more: 'Weitere Stile' },
    it: { any: 'Scegli tu per me', more: 'Altri stili' }
  };
  var N = 5;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || !inst._v18 || inst._v19) return;
    inst._v19 = true;
    function tx() { return TXT[inst.loc] || TXT.fr; }

    function tile(st) {
      var img = st.img ? st.img + (st.img.indexOf('?') > -1 ? '&' : '?') + 'width=320' : '';
      return '<li><button type="button" class="ais-style" data-act="pick-style" data-k="' + esc(st.key) + '" data-l="' + esc(st.label) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="160" height="160">' : '<span class="ais-style__ph" aria-hidden="true">' + esc(st.label.charAt(0)) + '</span>') +
        '<span class="ais-style__name">' + esc(st.label) + '</span></button></li>';
    }

    inst.showStyles = function () {
      var self = inst, run = inst.run;
      self.busy = true;
      self.loadStyles().then(function (d) {
        if (run !== self.run) return;
        self.busy = false;
        var t = tx(), ui = d.ui || {}, all = d.styles || [];
        var anyLabel = ui.any && ui.any.length > 3 ? ui.any : t.any;
        var deck = shuffle(all), pos = 0;
        function next() {
          var out = [];
          for (var i = 0; i < N && deck.length; i++) { out.push(deck[pos % deck.length]); pos++; }
          if (pos >= deck.length) { deck = shuffle(all); pos = 0; }
          return out;
        }
        var first = '<li><button type="button" class="ais-style ais-style--any" data-s19="any" data-l="' + esc(anyLabel) + '">' +
          '<span class="ais-style__ph ais-style__ph--any" aria-hidden="true"><svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="3"/><circle cx="9" cy="9" r="1" fill="currentColor"/><circle cx="15" cy="9" r="1" fill="currentColor"/><circle cx="12" cy="12" r="1" fill="currentColor"/><circle cx="9" cy="15" r="1" fill="currentColor"/><circle cx="15" cy="15" r="1" fill="currentColor"/></svg></span>' +
          '<span class="ais-style__name">' + esc(anyLabel) + '</span></button></li>';
        var html = '<div class="ais-v19"><ul class="ais-styles ais-styles--six" role="list">' + first + next().map(tile).join('') + '</ul>' +
          (all.length > N ? '<button type="button" class="ais-v19__more" data-s19="more"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 11a8 8 0 0 0-14-4.5L4 9"/><path d="M4 4v5h5"/><path d="M4 13a8 8 0 0 0 14 4.5L20 15"/><path d="M20 20v-5h-5"/></svg>' + esc(t.more) + '</button>' : '') + '</div>';
        inst.bot(html, true).then(function () {
          inst.s.pending = 'manu';
          inst.chips([]);
          var box;
          var all19 = inst.thread.querySelectorAll('.ais-v19'); box = all19[all19.length - 1];
          if (box) box._deck = next;
        });
      });
    };

    inst.thread.addEventListener('click', function (e) {
      var b = e.target.closest('[data-s19]');
      if (!b || inst.busy || b.disabled) return;
      var box = b.closest('.ais-v19'), kind = b.getAttribute('data-s19');
      if (kind === 'more') {
        var ul = box.querySelector('.ais-styles'), items = ul.querySelectorAll('li');
        var fresh = box._deck ? box._deck() : [];
        // l'ancienne grille s'efface en fondu puis les 5 styles sont remplacés (la 1re vignette reste)
        for (var i = 1; i < items.length; i++) items[i].remove();
        ul.insertAdjacentHTML('beforeend', fresh.map(tile).join(''));
        ul.classList.remove('is-fresh'); void ul.offsetWidth; ul.classList.add('is-fresh');
        return;
      }
      if (kind === 'any') {
        box.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
        inst.command('style-any', null, b.getAttribute('data-l'));
      }
    });
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
